<div ngbDropdown #dropDown="ngbDropdown" class="position-absolute">
  <div ngbDropdownAnchor class="dropdownAnchor" [style.left]="position.x" [style.top]="position.y"></div>
  <div ngbDropdownMenu class="py-1">
    @for (opt of options; track opt) {
      <button ngbDropdownItem (click)="doClick(opt)" class="px-3">
        @if (opt.icon) {
          <i class="bi me-2" [class]="opt.icon"></i>
        }
        <span>{{opt.text|translate}}</span>
      </button>
    }
  </div>
</div>
